import isEmail from 'validator/lib/isEmail';
import * as Yup from 'yup';

export const TestSchema = Yup.object().shape({
  name: Yup.string().required('Required'),
});

export type TestValues = Yup.InferType<typeof TestSchema>;

export const isValidEmail = (email: string) => isEmail(email, { allow_utf8_local_part: false });

export const notInBlackListEmail = (email: string) =>
  isEmail(email, {
    allow_utf8_local_part: false,
    host_blacklist: [
      'outlook.com',
      'gmail.com',
      'yahoo.com',
      'hotmail.com',
      'aol.com, zoho.com',
      'protonmail.com',
    ],
  });
